export const MISSING_POLICY_COMMENCE_HOLD_REASON =
  "MISSING_POLICY_COMMENCE_DATE";

export const getOrderGroupHoldReasons = (item, bids = []) => {
  const fromBids = (bids || [])
    .filter((b) => b.status === "HOLD" && b.holdReason)
    .map((b) => b.holdReason);
  if (fromBids.length) {
    return [...new Set(fromBids)];
  }
  return item?.holdReasons || [];
};

export const hasMissingPolicyCommenceHold = (item, bids = []) =>
  getOrderGroupHoldReasons(item, bids).includes(
    MISSING_POLICY_COMMENCE_HOLD_REASON,
  );
